/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browse_MarketplaceInputs */

const en_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Marketplace`)
};

const es_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar mercado`)
};

const fr_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir la marketplace`)
};

const de_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz durchsuchen`)
};

const ja_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケットプレイスを見る`)
};

const zh_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览市场`)
};

const ar_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح السوق`)
};

const id_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi Marketplace`)
};

const it_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora Marketplace`)
};

const ru_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор Маркетплейса`)
};

const pt_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar Marketplace`)
};

const ko_browse_marketplace = /** @type {(inputs: Browse_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓플레이스 둘러보기`)
};

/**
* | output |
* | --- |
* | "Browse Marketplace" |
*
* @param {Browse_MarketplaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const browse_marketplace = /** @type {((inputs?: Browse_MarketplaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browse_MarketplaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_browse_marketplace(inputs)
	if (locale === "es") return es_browse_marketplace(inputs)
	if (locale === "fr") return fr_browse_marketplace(inputs)
	if (locale === "de") return de_browse_marketplace(inputs)
	if (locale === "ja") return ja_browse_marketplace(inputs)
	if (locale === "zh") return zh_browse_marketplace(inputs)
	if (locale === "ar") return ar_browse_marketplace(inputs)
	if (locale === "id") return id_browse_marketplace(inputs)
	if (locale === "it") return it_browse_marketplace(inputs)
	if (locale === "ru") return ru_browse_marketplace(inputs)
	if (locale === "pt") return pt_browse_marketplace(inputs)
	return ko_browse_marketplace(inputs)
});